import ErrorMessage from "../errors/ErrorMessage";

export default function TextBox(props) {
  return (
    <div>
      {props.color ? (
        <textarea type="text"
          id={props.id}
          name={props.name}
          value={props.value}
          onChange={props.handleInputChange(props.name)}
          rows="10"
          cols="50"
          className={`bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg 
          focus:ring-${props.color}-primary focus:border-${props.color}-primary block w-full p-2.5 mb-4`}
          placeholder={props.placeholder} required="">

        </textarea>
      ) : (
        <textarea type="text"
          id={props.id}
          name={props.name}
          value={props.value}
          onChange={props.handleInputChange(props.name)}
          rows="10"
          cols="50"
          className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg 
          focus:ring-primary-200 focus:border-primary-200 block w-full p-2.5 mb-4"
          placeholder={props.placeholder} required="">

        </textarea>
      )}

      {props.error ? (
        <div className="-mt-2">
          <ErrorMessage message={props.message}></ErrorMessage>
        </div>
      ) : (
        ""
      )}
    </div>
  )
}